import { PayloadAction } from '@reduxjs/toolkit';
import { takeLatest, put } from 'redux-saga/effects';
import { StatusUpdatesAPI } from 'api/status-updates';
import { ChangeStatusUpdatesPayload, deleteStatusUpdate } from '../actions';
import { removeStatusUpdate } from '../slice';

function* deleteStatusUpdateManager(
  action: PayloadAction<ChangeStatusUpdatesPayload>,
) {
  const { payload } = action;

  try {
    yield put(removeStatusUpdate(payload.statusUpdate));

    yield StatusUpdatesAPI.deleteStatusUpdate(payload.statusUpdate);
    yield payload.onSuccess && payload.onSuccess();
  } catch {
    // TODO
  }
}
export const watchDeleteStatusUpdates = function* () {
  yield takeLatest(deleteStatusUpdate.type, deleteStatusUpdateManager);
};
